import type { RefOrGetter } from "ls/common/types";
import { useQuery } from "@tanstack/vue-query";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useFilePages(shortcut: RefOrGetter<string>) {
  const options = computed(() => queries.pages(toValue(shortcut)));
  const query = useQuery(options);
  return computed(() => query.data.value?.Pages);
}
